import { LinkButton } from '@pmi/dsm-react';
import { ChevronRightIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';
import Overlay from '../../shared/components/Overlay';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import DealDetails from './DealTabs/DealDetails';
import useGetDeals from '../../shared/hooks/useGetDeals';
import userAdminNavigate from '../../shared/hooks/userAdminNavigate';
import useAccountAlerts from '../../shared/components/AlertGroup/useAccountAlerts';
import styles from '../../shared/components/DealTab/dealTab.module.scss';
import useAdminVisitedPages from '../../shared/hooks/useAdminVisitedPages';

import { AllDeal } from '../../shared/models/DealModel';

export default function AgreementDetails() {
  const { dealId } = useParams<{ dealId: string }>();
  const {
    setSelectedHomeDeal,
    selectedHomeDeal,
    isLoading,
    isFetching,
    isError,
    data,
  } = useGetDeals({ allDealsEnabled: true });
  const { isAccountAlertFetching, isAccountAlertLoading } = useAccountAlerts({
    dynamicAlerts: true,
  });
  const visit = useAdminVisitedPages('agreement_details');

  const dealLoadedSuccessfully = !isFetching && !isLoading && !isError;
  const { navigate } = userAdminNavigate();

  const getSelectedLabel = () => {
    if (selectedHomeDeal) {
      if (selectedHomeDeal.dealName && selectedHomeDeal.dealName.length > 0) {
        return `${selectedHomeDeal.dealName} (${selectedHomeDeal.id})`;
      }
      return selectedHomeDeal.id;
    }
    return '';
  };

  useEffect(() => {
    if (!isLoading && !isFetching && data.length > 0 && dealId) {
      const dealExists = data.some((d) => d.id === dealId);
      if (!dealExists) {
        navigate('', { replace: true });
      }
    }
  }, [data, isLoading, isFetching, dealId]);

  useEffect(() => {
    if (!isLoading && !visit.isLoading) {
      visit.performFirstTimeVisit('table tbody tr');
    }
  }, [isLoading, visit.isLoading]);

  if (!selectedHomeDeal) {
    return <p>Loading...</p>;
  }

  return (
    <>
      {dealLoadedSuccessfully && selectedHomeDeal && (
        <div className="d-flex flex-column" role="main">
          <div className="mb-4">
            <div
              className={`${styles.dealDetailsBreadcrumb} agreement-breadcrumbs`}
            >
              <div className="d-block">
                <LinkButton
                  titleText="All Agreements"
                  className="p-0 m-0"
                  onClick={() => {
                    setSelectedHomeDeal(AllDeal);
                    navigate('', { state: { fromSideNav: false } });
                  }}
                />
              </div>
              <div className="d-block mx-1">
                <ChevronRightIcon className={styles.chevronRight} />
              </div>
              <div className="d-block">
                <span className={styles.selectedDealLabel}>
                  {selectedHomeDeal && getSelectedLabel()}
                </span>
              </div>
            </div>
          </div>
          <div className="homepage-deal-details-block">
            <DealDetails deal={selectedHomeDeal} />
          </div>
        </div>
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={
          isLoading ||
          isFetching ||
          isAccountAlertLoading ||
          isAccountAlertFetching ||
          visit.isLoading
        }
      />
    </>
  );
}
